import { useUserAffectations } from '@/shared/auth/useUserAffectations';
import isObject from 'lodash/isObject';
import { useMemo } from 'react';

/** FINESS des établissements des affectations `published` de l'utilisateur courant. */
export const useUserEtablissements = () => {
  const { data: affectations = [], isLoading } = useUserAffectations();

  const finess = useMemo(() => {
    const result = new Set<string>();
    affectations.forEach(({ status, etablissement }) => {
      if (status !== 'published' || !etablissement) return;
      const value = isObject(etablissement) ? etablissement.finess : etablissement;
      if (value) result.add(value);
    });
    return [...result];
  }, [affectations]);

  return { finess, isLoading };
};
